import React from 'react';

import {Typography} from 'views/components';
import {translate} from 'views/module';

const FormsEmptyState = () => {
  return (
    <Typography variant="h6" sx={{fontWeight: 700}}>
      {translate('client.ClientDetail.FormSettings.FormsFeed.Empty')}
    </Typography>
  );
};

export default React.memo(FormsEmptyState);
